$('.client-stories-slider').each(function() {

    let sliderContainer = $(this);

    sliderContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        // dots: true,
        // infinite: true,
        // speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        // cssEase: 'linear',
        prevArrow: '<button type="button" class="slick-prev"><span class="sr-only visually-hidden">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="sr-only visually-hidden">Next</span></button>',
        // responsive: [
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             arrows: false
        //         }
        //     }
        // ]
    });

});
